<script setup lang="ts">
  import LabResultUploadDialog from '@/components/projectDetail/LabResultsDrawer/LabResultUploadDialog.vue'
  import LabResultsIndex from '@/components/projectDetail/LabResultsDrawer/LabResultsIndex.vue'
  import { useGIPointsStore } from '@/stores/giPoints'
  import { computed } from 'vue'
  import HeaderWithActions from '@/components/projectDetail/components/HeaderWithActions.vue'
  import PrimaryButton from '@/components/shared/PrimaryButton.vue'

  const store = useProjectStore()
  const labResultsDrawer = ref<HTMLElement | null>(null)
  const boreholeSampleObservationStore = useBoreholeSampleObservationStore()
  const giPointStore = useGIPointsStore()
  const authorizationStore = useAuthorizationStore()

  useResizeableElement({
    ref: labResultsDrawer,
    widthProperty: 'labResultsDrawer',
    elementGetter: vDrawerElementGetter
  })

  const canAddBoreholeSampleObservation = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'add_boreholesampleobservation'
    })
  })

  const canUploadFile = computed(() => giPointStore.giPointsWithBorehole.length > 0)
</script>

<template>
  <v-navigation-drawer
    :temporary="true"
    :scrim="false"
    ref="labResultsDrawer"
    :model-value="store.labResultsDrawer.shown"
    :width="store.labResultsDrawer.width"
    :class="['lab-drawer', 'resize-handler-elevation']"
  >
    <HeaderWithActions>
      <template #default> Lab Results </template>
      <template #actions>
        <v-tooltip v-if="canAddBoreholeSampleObservation" text="Upload profiles">
          <template v-slot:activator="{ props }">
            <PrimaryButton
              v-bind="props"
              append-icon="mdi-plus"
              @click="boreholeSampleObservationStore.toggleUploadDialog"
              :disabled="!canUploadFile"
            >
              Import STOWA database
            </PrimaryButton>
          </template>
        </v-tooltip>
      </template>
      <template #subheader> Upload and manage lab result (STOWA) data </template>
    </HeaderWithActions>
    <v-divider />
    <LabResultsIndex />
    <LabResultUploadDialog :store="boreholeSampleObservationStore" />
  </v-navigation-drawer>
</template>

<style scoped>
  .resize-handler-elevation {
    border-right-width: 10px;
    z-index: 1;
    box-shadow: none;
  }

  .hidden {
    display: none;
    opacity: 0;
    transition: opacity 0.5s ease;
  }

  :deep(.v-navigation-drawer__content) {
    overflow-y: hidden;
  }

  .lab-drawer {
    transition: border-bottom-color 0.3s;
    border-right: 10px solid rgba(0, 0, 0, 0.1);
    overflow-y: hidden;
    height: 100%;
  }
</style>
